<template>
    <div style="padding: 0 50px 160px; margin-top: -1px;">
        <div class="report-image-grid">
            <div class="card-grid-item" v-for="(value, name) in tasks" :key="name.toString()">
                <h3 class="search-listing-title"><a class="search-candidate-title"><i v-bind:class="['search-listing-icon' , 'fa', value.iconClass]"></i> <span>{{value["displayName"]}}</span></a></h3>



                <div class="search-listing-body">{{value["description"]}}</div>

                <div class="search-listing-footer">
                    <!--ko if: provisional_resource == 'true' --><!--/ko-->

                    <!--ko if: provisional_resource == 'partial' && $parent.userIsReviewer --><!--/ko-->


                    
                    <!-- <a class="search-candidate-link"  data-bind="visible: point, click: mapLinkClicked" style="display: none;"><i class="fa fa-map-marker"></i> {{value.displayName}} </a> -->

                    <a class="search-candidate-link pull-right"  v-on:click="$emit('dash-event', {'topic': 'task-selected', 'task_name': name })"><i class="fa fa-search"></i>  Seleziona</a>
                    
                    <!--/ko-->
                    <!--ko if: $root.resourceEditorContext --><!--/ko-->

                </div>
                <!-- <button v-bind:class="['btn' , value.buttonClass, 'btn-block']"  v-on:click="$emit('dash-event', {'topic': 'task-selected', 'task_name': name })" 
                    
                    >{{value.displayName}}</button> -->
            </div>
        </div>
    </div>
</template>

<script>
import {dash_tasks, status_values} from '../utils/env';

export default {
    name: "TaskSelect",
    data: function() {
        return {
            'dash_tasks': dash_tasks,
            'status_values': status_values
        }
    },
    computed: {
        tasks: function() {
            let tasks_ = {};
            for(let key in dash_tasks) {
                if (![status_values.NO_TASK,status_values.TASK_SELECT].includes(key)) tasks_[key] = dash_tasks[key]
            }
            return tasks_;
        }
    }
}
</script>

<style scoped>

</style>